import { startAppListening } from "../listenerMiddleware";
import _ from "lodash";
import OrderArticle from "../../models/order/OrderArticle";
import { AppDispatch, RootState } from "../store";
import { simphonyApi } from "../api/simphonyApi.ts";
import { selectOracleDiscountIds } from "../selectors/selectCheckCalculatorDiscounts.ts";
import { mwiseSlice } from "../MWiseSlice.ts";
import { shoppingCartSlice } from "../shoppingCartSlice.tsx";

export function checkCalculate(state: RootState, dispatch: AppDispatch) {
  const items: OrderArticle[] = state.shoppingCart.items;

  const discountCardNr = state.shoppingCart.discountCardNr;
  const oracleDiscountIds = selectOracleDiscountIds(state);

  return new Promise((resolve, reject) => {
    dispatch(
      simphonyApi.endpoints.checkCalculator.initiate(
        {
          items: items,
          voucherOrderItems: [],
          discountCardNr,
          oracleDiscountIds,
        },
        { fixedCacheKey: "checkCalculator-SIMPHONY" }
      )
    )
      .then(() => {
        resolve(true);
      })
      .catch(() => {
        reject(true);
      });
  });
}

const debouncedCheckCalculate = _.debounce(checkCalculate, 1500);

export function checkCalculatorListener() {
  startAppListening({
    predicate: (__, currentState, previousState) => {
      const shoppingCartChanged =
        !_.isEqual(currentState.shoppingCart.items, previousState.shoppingCart.items) ||
        __.type === mwiseSlice.actions.rewardClaimed.type ||
        __.type === mwiseSlice.actions.rewardCanceled.type;

      return (
        currentState.global.salesarea.check_calculate_settings.enabled &&
        __.type !== shoppingCartSlice.actions.clearShoppingCart.type &&
        __.type !== shoppingCartSlice.actions.orderSucceeded.type &&
        shoppingCartChanged
      );
    },
    effect: (action, { dispatch, getState }) => {
      debouncedCheckCalculate(getState(), dispatch);
    },
  });
}
